module.exports = __webpack_public_path__ + "fonts/2be0671382fed0dcd14972d6a6de83b7.svg";